export default "__VITE_ASSET__CVMjPis6__"